export const LOGIN_URL = "/login";
export const LOGOUT_URL = "/logout";
export const REPAYMENT_LOGOUT_URL = "/repaymentLogout";

export const REPAYMENT_lOGIN_URL = "/repaymentLogin";
export const MANAGE_OTP_DETAILS_URL = "/manageOtp";

export const ABOUT_US_CONFIG_URL = "/sysAdmin/aboutUs";
export const CATEGORY_CONFIG_URL = "/sysAdmin/categoryConfig";
export const DISTRICT_CONFIG_URL = "/sysAdmin/districtConfig";

export const BANK_CONFIG_URL = "/sysAdmin/bankConfig";
export const BANKBRANCH_CONFIG_URL = "/sysAdmin/bankBranchConfig";
export const SCHEME_CONFIG_URL = "/sysAdmin/schemeConfig";
export const CONSTITUENCY_CONFIG_URL = "/sysAdmin/constituencyConfig";
export const SUBDIVISION_CONFIG_URL = "/sysAdmin/subDivisionConfig";
export const GRAMPANCHAYAT_CONFIG_URL = "/sysAdmin/gramPanchayatConfig";
export const SCHEMES_CONFIG_URL = "/sysAdmin/schemesConfig";
export const INTEREST_CONFIG_URL = "/sysAdmin/interestRateDetailsConfig";
export const AWARDS_CONFIG_URL = "/sysAdmin/awardsConfig";
export const PUBLICATIONS_CONFIG_URL = "/sysAdmin/publicationConfig";
export const NEWS_CONFIG_URL = "/sysAdmin/newsConfig";
export const PHOTO_GALLERY_CONFIG_URL = "/sysAdmin/photoGalleryConfig";
export const BROACHER_CONFIG_URL = "/sysAdmin/broacherConfig";
export const FAQ_CONFIG_URL = "/sysAdmin/faqConfig";
export const APPLICANT_PERSONAL_DETAILS_CONFIG_URL =
  "/sysAdmin/applicantPersonalDetailsConfig";
export const USER_MANAGEMENT_CONFIG_URL = "/sysAdmin/userManagementConfig";
export const NAGAR_PANCHAYAT_CONFIG_URL = "/sysAdmin/nagarPanchayatConfig";
export const MUNICIPAL_CORPORATION_CONFIG_URL =
  "/sysAdmin/municipalCorporationConfig";
export const EMPLOYEE_MANAGEMENT_CONFIG_URL =
  "/sysAdmin/employeeManagementConfig";
export const REPAYMENT_CONFIG_URL = "/sysAdmin/repaymentConfig";

export const REPORTS_CONFIG_URL = "/sysAdmin/reportsConfig";
export const FEEDBACK_CONFIG_URL = "/sysAdmin/feedbackConfig";
export const AUDIT_TRAIL_CONFIG_URL = "/sysAdmin/auditTrailConfig";
export const APPLICANT_REMARK_CONFIG_URL = "/sysAdmin/applicantRemarkConfig";
export const CHANGE_PASSWORD = "/sysAdmin/changePassword";
export const GET_LEDGER_DETAILS = "/sysAdmin/getLedgerDetails";
export const LEDGER_CONFIG_URL = "/sysAdmin/ledgerConfig";
export const GET_INTEREST_LEDGER_DETAILS = "/sysAdmin/getInterestLedgerDetails";
export const GET_PENAL_INTEREST_DETAILS = "/sysAdmin/getPenalInterestDetails";
export const GET_RECEIPT_REPAYMENT_DETAILS =
  "/sysAdmin/getReceiptRepaymentDetails";
export const GET_CHEQUE_RECEIPT_LIST_DETAILS =
  "/sysAdmin/getChequeReceiptListDetails";
export const GET_LOANEE_MINI_STATEMENT_URL =
  "/sysAdmin/get-loanee-mini-statement";

export const GET_INTEREST_ON_INTEREST_DETAILS =
  "/sysAdmin/getInterestOnInterstDetails";

export const GET_DASHBOARD_REPORT_URL = "/sysAdmin/getDashboardReport";

//Category wise Dashboard Details
export const GET_DASHBOARD_DETAILS_URL = "/sysAdmin/getDashboardDetails";
export const LOANEE_DETAILS_CONFIG = "/sysAdmin/loaneeDetailsConfig";
export const OTS_CONFIG_URL = "/sysAdmin/oneTimeSettlementConfig";
export const SEND_MAIL_URL = "/sendmail";

export const NOTICE_URL = "/sysAdmin/noticeConfig";
export const AREA_CONFIG_URL = "sysAdmin/areaConfig";
export const DESIGNATION_CONFIG_URL = "sysAdmin/designationConfig";
export const MST_CASHCOUNTER_CONFIG_URL = "sysAdmin/cashCounterConfig";
export const MEDIA_CONFIG_URL = "sysAdmin/mediaConfig";
export const MEDIA_ITEMS_CONFIG_URL = "sysAdmin/mediaItemsConfig";
export const CASHCOUNTER_CONFIG_URL = "sysAdmin/cashCounter_Config";
export const YEARLY_COMPILED_REPORT_URL = "sysAdmin/yearlyCompiledReport";
export const NOTIFICATION_CONFIG_URL = "sysAdmin/notificationConfig";
export const YEARLY_WISE_REPORT_URL = "sysAdmin/yearlyWiseReport";

//#region Public URLs

export const ABOUT_US_PUBLIC_URL = "/aboutus";
export const SCHEMES_LIST_PUBLIC_URL = "/schemeslist";
export const NOTICE_BOARD_LIST_URL = "/noticeboard";
export const PHOTOGALLERY_LIST_URL = "/photogallery";
export const AWARDS_LIST_URL = "/awards";
export const FAQs_LIST_URL = "/faqs";
export const NEWs_EVENTs_LIST_URL = "/newsEvents";
export const FEEDBACK_URL = "/feedback";
export const AWS_ACCESS_URL = "/getAWSAccess";
export const RAS_KEY_URL = "/getRsaPublicKey";
export const CAPTCHA_URL = "/getCaptcha";
export const ROLELIST_URL = "/rolelist";
export const EMPLOYEE_DETAIL_URL = "/employeelist";

export const CREATE_ORDER_API = "/payment";
export const PUBLIC_REPAYMENT_CONFIG_URL =
  "/getPrincipleDueWithInterestUntilDate";

export const PUBLIC_NOC_APPLICATION = "/public-noc-application";

//#endregion

export const LOANEE_DEATH_CASE = "/sysAdmin/loaneeDeathCaseCongfig";
export const NOC_APPLICATION_LIST_URL = "/sysAdmin/nocApplicationListCongfig";
export const VERIFY_NOC_APPLICATION_URL =
  "/sysAdmin/verifyNocApplicationCongfig";

export const EMP_DESIGNATION_URL = "/sysAdmin/empDesigantionConfig";
export const EMP_DETAILS_URL = "/sysAdmin/empDetailsConfig";

export const DEFAULTER_DOCS_URL = "/sysAdmin/defaulterDocs";
export const DEFAULTER_LOAN_REMINDER =
  "/sysAdmin/loanReminderConfig/sendLoanReminder";

// noc url
export const GET_NOC_DASHBOARD_REPORT_URL =
  "/public-noc-application/get/noc-report";
